import SidebarV2 from './SidebarV2'

export default SidebarV2
